var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgThalesLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 157,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M104.844 14.93v3.22c-6.098 1.219-12.147 1.219-18.149 0V.879h4.294V14.93h13.855ZM0 .88a65.106 65.106 0 0 1 21.32 0v3.074h-8.537V18.15H8.49V3.953H0V.879ZM130.653 14.93v3.219c-6.439 1.219-12.831 1.219-19.125 0V.879a51.157 51.157 0 0 1 18.881 0v3.074h-14.538v3.512h8.489v3.464h-8.489v4.002h14.782Z",
  fill: "#353581"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M71.425 12.833c0 .829-.293 1.56-.878 2.145-.634.585-1.366.879-2.196.879-.83 0-1.513-.294-2.146-.879-.586-.585-.878-1.315-.878-2.145 0-.83.293-1.562.878-2.148.585-.634 1.317-.927 2.146-.927.83 0 1.561.294 2.196.927.585.585.878 1.318.878 2.148Z",
  fill: "#8DC2BB"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M46.202 7.465H33.86V.488l-3.952.488v17.368l3.952.489v-7.856h12.343v7.856l3.952-.489V.976L46.202.439v7.026ZM68.4 4.197l7.904 14.49 4.294-.538-2.001-3.463-.049-.05L70.547.88h-3.952l-9.952 17.27 3.854.489L67.23 6.294l.048-.049L68.4 4.197Zm72.548 3.414V3.953h15.807V.879a47.696 47.696 0 0 0-9.318-.78c-3.075 0-5.709.292-8.002.926-.829.244-1.463.634-1.804 1.22-.342.586-.538 1.512-.538 2.732V6.88c0 1.61.341 2.682 1.025 3.269.634.536 1.854.827 3.611.827h11.416v3.954h-16.051v3.219l10.344.829v-.05c2.584 0 5.023-.34 7.318-.975.829-.194 1.415-.585 1.756-1.22.342-.584.488-1.463.488-2.682V11.71c0-1.61-.342-2.684-.977-3.27-.634-.536-1.804-.829-3.609-.829h-11.466v.001Z",
  fill: "#353581"
})));

export { SvgThalesLogo as ReactComponent };
export default __webpack_public_path__ + "c2803c6d76c7e6561df5c8d9e0808ea7.svg";